// Utility function to normalize text (removes accents and converts to lowercase)
export function normalizeText(text: string): string {
    return text.toLocaleLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
}
